import {useEffect} from 'react';
import {useControllers} from './useControllers';

export function useSubtitle(subtitle: string): void {
    const controllers = useControllers();
    useEffect(() => {
        controllers.settings.set('subtitle', subtitle).andWeAreDone();
    });
}
